"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLoading = exports.LoadingProvider = void 0;
var react_1 = __importStar(require("react"));
var react_dom_1 = __importDefault(require("react-dom"));
var Loading_1 = require("../componentes/Loading/Loading");
var Modal_1 = require("../componentes/Modal/Modal");
var LoadingContext = (0, react_1.createContext)(undefined);
var loadingReducer = function (state, action) {
    switch (action.type) {
        case "MOSTRAR_LOADING":
            return { count: state.count + 1 };
        case "ESCONDER_LOADING":
            return { count: Math.max(state.count - 1, 0) };
        case "RESET_LOADING":
            return { count: 0 };
        default:
            return state;
    }
};
var LoadingProvider = function (props) {
    var _a = (0, react_1.useReducer)(loadingReducer, { count: 0 }), state = _a[0], dispatch = _a[1];
    var mostrarLoading = function () {
        dispatch({ type: "MOSTRAR_LOADING" });
    };
    var esconderLoading = function () {
        dispatch({ type: "ESCONDER_LOADING" });
    };
    var resetLoading = function () {
        dispatch({ type: "RESET_LOADING" });
    };
    return (react_1.default.createElement(LoadingContext.Provider, { value: { mostrarLoading: mostrarLoading, esconderLoading: esconderLoading, resetLoading: resetLoading } },
        props.children,
        react_dom_1.default.createPortal(react_1.default.createElement(ModalLoading, { loading: state.count > 0 }), document.body)));
};
exports.LoadingProvider = LoadingProvider;
var ModalLoading = function (props) {
    return (react_1.default.createElement(Modal_1.Modal, { isOpen: props.loading, onClose: function () { }, style: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "transparent",
            width: "100%",
            height: "100%",
            boxShadow: "none",
        } },
        react_1.default.createElement("div", { style: {
                position: "relative",
                width: "100px",
                height: "100px",
            } },
            react_1.default.createElement(Loading_1.Loading, { carregandoConteudo: props.loading }))));
};
var useLoading = function () {
    var context = (0, react_1.useContext)(LoadingContext);
    if (!context) {
        throw new Error("useLoading deve ser usado dentro de um LoadingProvider");
    }
    return context;
};
exports.useLoading = useLoading;
